import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Approach from "./components/Approach";
import Contact from "./components/Contact"; // Importado
import Footer from "./components/Footer"; // Importado
import Benefits from "./components/Benefits";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Services />
        <Approach />
        <Benefits />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
